import styled from '@emotion/styled'

export const GuideFormWrapper = styled.form``
